import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { isBeforeBreak } from '../scheduleHelper';
import ScheduleRowMobile from './ScheduleRowMobile';
// import ScheduleBreak from '../ScheduleBreak';

const createSchedule = (selectedDateSchedule) =>
  selectedDateSchedule.map((scheduledClass) => (
    <ScheduleRowMobile
      key={scheduledClass.programme.uid}
      data={scheduledClass}
    />
  ));

const ScheduleMobile = ({ schedule, selectedDate }) => {
  const selectedDateSchedule = useMemo(() => {
    const selectedSchedule =
      schedule.find((daySchedule) => daySchedule.date === selectedDate) || {};
    return selectedSchedule.data || [];
  }, [schedule, selectedDate]);

  const scheduleContent = useMemo(() => {
    let scheduleBeforeBreak = selectedDateSchedule;
    let scheduelAfterBreak = [];
    const breakIndex = selectedDateSchedule.findIndex(
      (scheduledClass) => !isBeforeBreak(scheduledClass.live_at)
    );
    if (breakIndex > -1) {
      scheduleBeforeBreak = selectedDateSchedule.slice(0, breakIndex);
      scheduelAfterBreak = selectedDateSchedule.slice(breakIndex);
    }
    return (
      <>
        {createSchedule(scheduleBeforeBreak)}
        {/* {scheduelAfterBreak.length > 0 && (
          <ScheduleBreak key="schedule-break" />
        )} */}
        {createSchedule(scheduelAfterBreak)}
      </>
    );
  }, [selectedDateSchedule]);

  return scheduleContent;
};

ScheduleMobile.propTypes = {
  schedule: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedDate: PropTypes.string.isRequired
};

export default ScheduleMobile;
